import { LearningObject } from "@app/common/models/learning-object";

export class GameState extends LearningObject{
    public personId: string;
    public courseCode: string;
    public gameId:string;
    public gameType:number;
    public state:string;
}